"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = exports.providers = void 0;
var providers = {
  INJECTED: 'INJECTED',
  CONNECTED: 'CONNECTED'
};
exports.providers = providers;
var events = {
  ACCOUNTS_CHANGED: 'accountsChanged',
  CHAIN_CHANGED: 'chainChanged',
  DISCONNECT: 'disconnect'
};
exports.events = events;